var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfiguration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6475 8.79244C17.6449 8.77499 17.6423 8.75751 17.6398 8.74L20 6.72L17.9296 3.26L14.9275 4.24C14.265 3.7 13.5197 3.28 12.6915 2.98L12.0704 0H7.92961L7.30849 2.98C6.48033 3.28 5.73499 3.7 5.07246 4.24L2.07039 3.26L0 6.72L2.36025 8.74C2.35766 8.75754 2.35506 8.77504 2.35247 8.79252C2.29306 9.19348 2.23602 9.57837 2.23602 10C2.23602 10.4216 2.29306 10.8065 2.35247 11.2075C2.35506 11.225 2.35766 11.2425 2.36025 11.26L0 13.28L2.07039 16.74L5.07246 15.76C5.73499 16.3 6.48033 16.72 7.30849 17.02L7.92961 20H12.0704L12.6915 17.02C13.5197 16.72 14.265 16.3 14.9275 15.76L17.9296 16.74L20 13.28L17.6398 11.26C17.6423 11.2425 17.6449 11.225 17.6475 11.2075C17.7069 10.8066 17.764 10.4216 17.764 10C17.764 9.57835 17.7069 9.19343 17.6475 8.79244ZM5.85921 10C5.85921 12.2 7.72257 14 10 14C12.2774 14 14.1408 12.2 14.1408 10C14.1408 7.8 12.2774 6 10 6C7.72257 6 5.85921 7.8 5.85921 10Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.dcc65e00.svg";
export { ForwardRef as ReactComponent };